export default __webpack_public_path__ + "static/media/pcc.424d5a9b.png";